<div class="content" role="main">
  <img src="https://uploads-ssl.webflow.com/62e7baff16ec36495482a367/62e80d76efedf4f5838b4bd0_logo.svg" alt="Logo of KaDeck"  style="width: 290px; margin-bottom: 130px"/>

<h1>Please wait. You will be redirected.</h1>
  <p style="height: 2000px">If you are not redirected, <a  href="https://www.kadeck.com">click here</a>.</p>
</div>
